import { assign, isFunction, deepMix, get, each, has } from '@antv/util';
import { Label } from '../../interface/config';
import { combineFormatter, getNoopFormatter, getPrecisionFormatter, getSuffixFormatter } from '../../util/formatter';
import { LooseMap } from '../../interface/types';

export default class LabelParser {
  public config: LooseMap = {};
  protected plot: any;
  protected originConfig: Label;

  constructor(cfg) {
    const { plot, ...rest } = cfg;
    this.plot = plot;
    this.originConfig = rest;
    this.init(cfg);
  }

  public getConfig() {
    return this.config;
  }

  protected init(cfg) {
    assign(this.config, cfg);
    this.config.callback = (val) => {
      return this.parseCallBack(val);
    };
  }

  protected parseCallBack(val) {
    const labelProps = this.originConfig;
    const theme = this.plot.getPlotTheme();
    const config: LooseMap = { ...labelProps };
    this.parseOffset(labelProps, config);
    if (labelProps.position) {
      if (isFunction(labelProps.position)) {
        config.position = labelProps.position(val);
      } else {
        config.position = labelProps.position;
      }
    }
    this.parseFormatter(config);
    if (labelProps.style) {
      if (isFunction(labelProps.style)) {
        config.textStyle = labelProps.style(val);
      } else {
        config.textStyle = labelProps.style;
      }
    }
    config.textStyle = deepMix({}, get(theme, 'label.style'), config.textStyle);
    if (labelProps.autoRotate) {
      config.autoRotate = labelProps.autoRotate;
    }

    return config;
  }

  protected parseOffset(props, config) {
    const mapper = ['offset', 'offsetX', 'offsetY'];
    let count = 0;
    each(mapper, (m) => {
      if (has(props, m)) {
        config[m] = props[m];
        count++;
      }
    });
    // 如用户没有设置offset，而label position又为middle时，则默认设置offset为0
    if (count === 0 && get(props, 'position') === 'middle') {
      config.offset = 0;
    }
  }

  protected parseFormatter(config: LooseMap) {
    const labelProps = this.originConfig;
    config.content = (data, index) => {
      // @ts-ignore
      const text = data[labelProps.fields[0]];
      return combineFormatter(
        getNoopFormatter(),
        getPrecisionFormatter(labelProps.precision),
        getSuffixFormatter(labelProps.suffix),
        (labelProps.formatter as (text: string, item: any, idx: number) => string)
          ? labelProps.formatter
          : getNoopFormatter()
      )(text, data, index);
    };
  }
}
